import apiClient from './client';
import type { ApiResponse } from '../types';

/**
 * Exchange the current Bearer JWT for a short-lived single-use WebSocket
 * handshake ticket. The socket connects with `?ticket=<t>` instead of the
 * full access token so the long-lived JWT never rides in the ws URL (and
 * thus not in nginx access logs, browser history, or Referer headers).
 *
 * Returns null when the ticket endpoint is unavailable (e.g. Redis blip →
 * 503); the caller then falls back to the legacy `?token=` handshake so
 * realtime never hard-breaks.
 */
export const realtimeApi = {
  async wsTicket(): Promise<string | null> {
    try {
      const res = await apiClient.post<ApiResponse<{ ticket: string; expires_in: number }>>(
        '/vendor/ws-ticket',
      );
      return res.data?.data?.ticket ?? null;
    } catch {
      return null;
    }
  },
};
